import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);

  const login = (userData, companyData, accessToken) => {
    setUser(userData);
    setCompany(companyData);
    setToken(accessToken);
  };

  const logout = () => {
    setUser(null);
    setCompany(null);
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ user, company, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
